__turbopack_context__.v({
  "actions": "styles-module-scss-module__-sRBfq__actions",
  "alignDividerMargin": "styles-module-scss-module__-sRBfq__alignDividerMargin",
  "content": "styles-module-scss-module__-sRBfq__content",
  "divider": "styles-module-scss-module__-sRBfq__divider",
  "middleTitle": "styles-module-scss-module__-sRBfq__middleTitle",
  "mobileDivider": "styles-module-scss-module__-sRBfq__mobileDivider",
  "title": "styles-module-scss-module__-sRBfq__title",
});
